export default {
  placeholder: 'Caută restaurant...',
};
